
import { Template, LazyTemplate } from "../../../core/template/index";
import { View } from "../../../core/view";

export default class TestStep01View extends View
{
    public template = Template.lazy('/views/testChain/step01/index.html');
}